<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
                <a-form-item label="type" name="type">
                    <a-input v-model:value="form.type"/>
                </a-form-item>
            </div>
            <a-row :gutter="20">
                <a-col :span=24>
                    <a-form-item label="名称" name="honorsName">
                        <a-input v-model:value="form.honorsName" placeholder="请输入名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span=24>
                    <a-form-item label="认定时间" name="attestationTime">
                        <date-picker v-model:value="form.attestationTime" placeholder="请输入名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="认证机构" name="attestationMechanism">
                        <a-input v-model:value="form.attestationMechanism" placeholder="请输入认证机构"/>
                    </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="图片" name="natural">
                        <img-upload v-model:value="form.natural"/>
                    </a-form-item>
                </a-col>

                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
// import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {honor} from "@/api/companyService";
import ImgUpload from "@/components/form/upload/ImgUpload";
import DatePicker from "@/components/form/datePicker/DatePicker";

export default {
    name: "AddOrEditModal",
    components: {DatePicker, ImgUpload},

    mixins: [formMixin],
    data() {
        return {
            form: {
                id: null,
                type: null,
                honorsName: null,
                natural: null,
                attestationTime: null,
                attestationMechanism: null,

            },
            rules: {
               id:[],
                type:[],
                honorsName:[],
                natural:[],
                attestationTime:[],
                attestationMechanism:[],
            },
            submitUrl: honor.saveOrUpdate
        }
    },
    created() {
    },
    methods: {

    },
}
</script>
<style scoped lang="less">
</style>
